import type { ReactNode } from 'react';
import { motion } from 'motion/react';
import { useLocation } from 'wouter';

/**
 * Enter-only route transition: a quick fade + 6px rise when the path changes.
 * Deliberately no exit phase — navigation must stay instant in a working tool.
 * Honors reduced motion via the app-level <MotionConfig reducedMotion="user">.
 */
export function PageTransition({ children }: { children: ReactNode }) {
  const [location] = useLocation();
  return (
    <motion.div
      key={location}
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
